// import { buttonIconOnlyCommonStyles } from "@iewcasia/Utilities/styleguide";
import { colorStrings, mediaQueriesBP } from "@iewcasia/Utilities/variables";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import baseTheme from "@insite/mobius/globals/baseTheme";
import { IconWrapper } from "@insite/mobius/Icon";
import { ModalPresentationProps } from "@insite/mobius/Modal";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

export const buttonIconOnlyCommonStyles: ButtonPresentationProps = {
    variant: "primary",
    css: css`
        width: 24px;
        padding: 0;
        height: 24px;
        min-height: 24px;
        background-color: transparent;
        border: 0;

        &:hover,
        &:focus,
        &:disabled {
            ${IconWrapper} {
                color: ${getColor(colorStrings.commonGlobalWhite)};
                height: 100%;
                width: auto;
            }
        }

        ${mediaQueriesBP.minMD} {
            height: 24px;
            min-height: 24px;
            padding: 0;
        }

        ${IconWrapper} {
            top: 0;
            color: ${getColor(colorStrings.primaryMain)};
        }
    `,
    mergeCss: true,
};

export const modal: {
    sizeVariants: {
        small: number;
        medium: number;
        large: number;
    };
    defaultProps?: ModalPresentationProps;
} = {
    sizeVariants: {
        small: 500,
        medium: 800,
        large: 1110,
    },
    defaultProps: {
        cssOverrides: {
            modalTitle: css`
                border-bottom: 1px solid ${getColor(colorStrings.commonBorder)};
                padding: 16px;
                ${mediaQueriesBP.minMD} {
                    padding: 24px 40px;
                }
            `,
            modalContainer: css`
                box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
            `,
            modalContent: css`
                font-size: 16px;
                line-height: 19px;
                padding: 16px;
                margin: 0;

                p {
                    font-size: 16px;
                    line-height: 19px;

                    ${mediaQueriesBP.minMD} {
                        font-size: 18px;
                    }
                }

                ${mediaQueriesBP.minMD} {
                    padding: 24px 40px;
                    font-size: 18px;
                }
            `,
        },
        closeButtonProps: {
            ...buttonIconOnlyCommonStyles,
        },
        closeButtonIconProps: {
            src: "X",
            size: 20,
            color: colorStrings.primaryMain,
        },
        headlineTypographyProps: {
            weight: "bold",
            variant: "h3",
            forwardAs: "h3",
        },
        mergeCss: true,
    },
};
